module.exports = __webpack_public_path__ + "img/curved-rail-horizontal-right-top-stone-path-background.c78e691d.png";